import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";

import {
  ListSousCategories,
  ListSousCategoriesByCategorie,
  currentpage,
  findSousCategorieByLibelleApi,
  findSousCategorieBySocieteApi,
  findSousCategoriesApi,
  findSousCategoriesByCategorieApi,
  insertSousCategorieApi,
  totalPages,
} from "../../_App/Redux/Slices/souscategories/souscategorieSlice";
import SousCategoriesList from "../../Components/SousCategories/SousCategoriesList";
import { useParams } from "react-router";
import SousCategorieForm from "../../Components/SousCategories/SousCategorieForm";
import {
  SelectedOrganisationId,
  societeId,
} from "../../_App/Redux/Slices/Auth/authSlice";
import PaginationLayout from "../../_Layouts/Pagination/PaginationLayout";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import { ToastSuccess } from "../../Shared/Toasts/ToastSuccess";
import { ToastWarning } from "../../Shared/Toasts/ToastWarning";
import * as XLSX from "xlsx";

const SousCategoriesPage = () => {
    const { t } = useTranslation();
    const [ShowModalImport, setShowModalImport] = useState(false);
  
  const { idcategorie } = useParams();
  const [index, setindex] = useState(1);
  const currentOrganisation = useAppSelector(SelectedOrganisationId);


const [file, setfile] = useState<File | undefined>();

const handleExcelImport = async () => {
  if (!file) {
    ToastWarning("Veuillez sélectionner un fichier.");
    return;
  }

  Swal.fire({
    title: "Chargement...",
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });

  try {
    // Lire le fichier Excel
    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target?.result as ArrayBuffer);
      const workbook = XLSX.read(data, { type: "array" });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      // Appel de l'API avec les données JSON
      const response = await dispatch(insertSousCategorieApi({ data: jsonData, societe }));

      if (response.payload.success) {
        ToastSuccess(t(response.payload.message));
        window.location.reload();
      } else {
        ToastWarning(t(response.payload.message));
      }

      Swal.close();
    };

    reader.readAsArrayBuffer(file);
  } catch (error) {
    console.error("Error:", error);
    ToastWarning("Une erreur est survenue.");
    Swal.close();
  }
};

  const [showModalSousCategorie, setShowModalSousCategorie] = useState(false);
  const [selectedSousCategorie, setSelectedSousCategorie] = useState(null);
  const dispatch = useAppDispatch();
  const sousCategories = useAppSelector(ListSousCategories);
  const sousCategoriesByCategorie = useAppSelector(
    ListSousCategoriesByCategorie
  );
  const societe = useAppSelector(societeId);
  const current_page = useAppSelector(currentpage);
  const totalpages = useAppSelector(totalPages);
  const [libelle, setLibelle] = useState("");
  useEffect(() => {
    if (libelle !== "") { 
      const data = { societe_id: societe, index: index, libelle: libelle };
      dispatch(findSousCategorieByLibelleApi(data));
    } else {
      const data = { societe: societe, index: index };
      dispatch(findSousCategorieBySocieteApi(data));
    }
  }, [societe, index]);

  useEffect(() => {
    if (idcategorie) {
      dispatch(findSousCategoriesByCategorieApi(idcategorie));
    } else if (currentOrganisation) {
      dispatch(findSousCategoriesApi(currentOrganisation));
    }
  }, [dispatch, idcategorie]);

  const openEditForm = (sousCategorie: any) => {
    setSelectedSousCategorie(sousCategorie);
    setShowModalSousCategorie(true);
  };
  const handleSearch = async () => {
    if(libelle !==''){
      const data = { societe_id: societe, index: 1, libelle: libelle };
      dispatch(findSousCategorieByLibelleApi(data))
    }else{
      const data = { societe: societe, index: index };
      dispatch(findSousCategorieBySocieteApi(data));
    }
   ;
    setindex(1);
  };

  return (
    <div>
      <div className="d-flex justify-content-end mb-3 mt-5">
        <button
          className=" btn btn-primary-app col-2"
          onClick={() => setShowModalSousCategorie(true)}
        >
         {t('Ajouter une Famille')} 
        </button>
         <button
          onClick={() => {
            setShowModalImport(true);
          }}
          className="btn btn-primary-app"
        >
          {t("Import  Famille")}
        </button>{" "}
      </div>
      <SousCategorieForm
        ShowModal={showModalSousCategorie}
        setShowModal={setShowModalSousCategorie}
        sousCategorie={selectedSousCategorie}
        categorie_id={idcategorie}
        currentOrganisation={currentOrganisation}
        societe={societe}
      />

      <SousCategoriesList
        sousCategoriesListe={
          idcategorie ? sousCategoriesByCategorie : sousCategories
        }
        onEditClick={openEditForm}
        setLibelle={setLibelle}
        libelle={libelle}
        handleSearch={handleSearch}
      />
      <div className="row layout-spacing">
        <PaginationLayout
          index={index}
          nbrpage={current_page}
          totalpages={totalpages}
          setindex={setindex}
        />
      </div>
      <Modal
              show={ShowModalImport}
              onHide={() => setShowModalImport(false)}
              className="modal-1"
              dialogClassName="modal-30w"
              backdropClassName="modal-backdrop-1"
            >
              <Modal.Header>
                {" "}
                <div className="  c-primary">{t("Insert Famille par improt")} </div>
              </Modal.Header>
              <Modal.Body>
                <p className="c-primary">{t("Importer fichier")}</p>
                <p className="  form-control">
                  <input type="file" onChange={(e) => setfile(e.target.files?.[0])} />
                  <button onClick={handleExcelImport}>
                    <i className="fas fa-file-import"></i>
                  </button>
                </p>
              </Modal.Body>
            </Modal>
    </div>
  );
};

export default SousCategoriesPage;
